import i18n from '../../i18n'
export const platforms = [
  {
    key: 'tv-cable',
    selected: true,
    name: i18n.tc('tvChannels.platforms.cable')
  },
  {
    key: 'tv-satelit',
    name: i18n.tc('tvChannels.platforms.satellite')
  },
  {
    key: 'tv-ott',
    name: i18n.tc('tvChannels.platforms.ott')
  }
]
